<template>
    <div class="bag">
        <button @click="coveralls">编辑个人工服信息</button>
        <div class="button" v-if="phone">
            <p>如有疑问请联系当地分公司：<span>{{phone}}</span></p>
            <p>（10:00-12:00，14:00-18:00）</p>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      phone: this.$store.state.companyPhone,
      workType: this.$store.state.workType
    }
  },
  methods: {
    coveralls () {
      this.$router.push({name: 'editCoveralls'})
    }
  }
}
</script>
<style lang="scss" scoped>
.button{
    font-size: .24rem;
    color: #19191A;
    padding: .4rem .3rem;
    text-align: center;
    p span{
        color: #2A2AFF;
    }
}
 button{
       background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
        border-radius: 2px;
        height: .92rem;
        line-height: .92rem;
        width: 84%;
        color: #fff;
        border: none;
        border-radius: .04rem;
        font-size: .3rem;
        vertical-align: bottom;
        margin: .6rem 0 0 8%;
        padding: 0
    }
    .bag{
      background: #fff;
      // padding: 0 .3rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/BottomLayout.vue